import HistoryRow from 'Components/HistoryRow';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { isNil } from 'Utility/ramdaReplacement';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'huntingtonSymptoms'>[] = [];
const HuntingtonSymptoms = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'huntingtonSymptoms'>>): React.JSX.Element => {
  const huntingtonSymptoms = filterDocumentsByType(documents, ['huntingtonSymptoms'])
    .sort(sortDocumentsDescending)
    .at(0);

  return (
    <HistoryRow
      headerText={fm('diagnosis.huntingtonSymptoms')}
      rowButton={
        startEdit
          ? newButton(
              'huntingtonSymptoms',
              startEdit(huntingtonSymptoms ?? {}, 'huntingtonSymptoms'),
              'general.edit',
              undefined,
              undefined,
              !isNil((huntingtonSymptoms ?? {})._lockedFor),
              undefined,
              undefined,
              huntingtonSymptoms,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(huntingtonSymptoms)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('diagnosis.symptomOnsetDate')}
          value={
            huntingtonSymptoms?.symptomOnsetDate ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {formatPartialDate(huntingtonSymptoms.symptomOnsetDate)}
              </div>
            ) : (
              ' - '
            )
          }
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.huntingtonSymptom.title')}
          value={
            huntingtonSymptoms?.symptoms ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {fm(`diagnosis.huntingtonSymptom.opts.${huntingtonSymptoms.symptoms}`)}
              </div>
            ) : (
              ' - '
            )
          }
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.huntingtonSymptom.additionalInformation')}
          value={
            huntingtonSymptoms?.additionalInformation ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>{huntingtonSymptoms.additionalInformation}</div>
            ) : (
              ' - '
            )
          }
        />
      </React.Fragment>
    </HistoryRow>
  );
};

export default HuntingtonSymptoms;
